import { render, staticRenderFns } from "./ViewRecipe.vue?vue&type=template&id=1ec7826e&"
import script from "./ViewRecipe.vue?vue&type=script&lang=js&"
export * from "./ViewRecipe.vue?vue&type=script&lang=js&"
import style0 from "./ViewRecipe.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VContainer,VImg,VSkeletonLoader})
